import { cn } from '@/lib/utils';

const Label = ({
    variant = 'default',
    color = 'black',
    className,
    ...props
}: React.HTMLAttributes<HTMLHeadingElement> & {
    variant?: 'default' | 'button';
    color?: 'black' | 'inherit';
}) => {
    const variantClasses = {
        default:
            'lg:text-[14px] pr-1.5 text-[12px] 2xl:text-[18px] pressura uppercase inline-block leading-[120%]',
        button: 'lg:text-[18px] text-[16px] 2xl:text-[20px] abc-italic inline-block ',
    };

    const colorClasses = {
        black: 'text-black',
        inherit: 'text-inherit',
    };

    return (
        <span
            className={cn(
                variantClasses[variant],
                colorClasses[color],
                className,
            )}
            {...props}
        />
    );
};

Label.displayName = 'Label';

export default Label;
